import React, { useState } from 'react';
var styles = {
  "card": "_xsi02",
  "cardTitle": "_2yKGs",
  "animate-title-out": "_1H_aI",
  "cardHovered": "_-MJ6C",
  "cardBackgroundImage": "_2NQek",
  "cardImage": "__wvBT",
  "cardDescriptionHover": "_3uuI8",
  "animate-title": "_3NbVf",
  "animate-description": "_3hBoU"
};

var HoverableCard = function HoverableCard(_ref) {
  var cardTitle = _ref.cardTitle,
      cardDescription = _ref.cardDescription,
      cardImage = _ref.cardImage,
      hoverBgColor = _ref.hoverBgColor;

  var _useState = useState(false),
      isHovered = _useState[0],
      setIsHovered = _useState[1];

  var renderBackground = function renderBackground() {
    if (isHovered) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
        src: cardImage,
        className: styles.cardBackgroundImage
      }));
    }

    return null;
  };

  var _onMouseEnter = function onMouseEnter() {
    setIsHovered(true);
  };

  var _onMouseLeave = function onMouseLeave() {
    setIsHovered(false);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.card,
    style: isHovered ? {
      backgroundColor: hoverBgColor || 'grey'
    } : {},
    onMouseEnter: function onMouseEnter() {
      return _onMouseEnter();
    },
    onMouseLeave: function onMouseLeave() {
      return _onMouseLeave();
    }
  }, renderBackground(), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    className: styles.cardImage,
    src: cardImage
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.cardDescriptionHover
  }, cardDescription)), /*#__PURE__*/React.createElement("div", {
    className: styles.cardTitle
  }, cardTitle));
};

export { HoverableCard };